import { Components, Theme } from '@mui/material/styles';

// テーマ1: プロフェッショナル - コンポーネントカスタマイズ
export const components: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        padding: '8px 20px',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }
      },
      containedPrimary: {
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        '&:hover': {
          background: 'linear-gradient(135deg, #152a52 0%, #1e3c72 100%)'
        }
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
        }
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 12
      },
      elevation1: {
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      },
      elevation2: {
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }
    }
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 8,
          '&:hover fieldset': {
            borderColor: '#2a5298'
          },
          '&.Mui-focused fieldset': {
            borderColor: '#1e3c72',
            borderWidth: 2
          }
        }
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        fontWeight: 600
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: '#f5f7fa',
        '& .MuiTableCell-head': {
          fontWeight: 700,
          color: '#1e3c72',
          borderBottom: '2px solid #2a5298'
        }
      }
    }
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(42, 82, 152, 0.04)'
        }
      }
    }
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: 'none',
        boxShadow: '4px 0 12px rgba(0,0,0,0.08)'
      }
    }
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
      }
    }
  }
};
